import type { ExcRouteV1FixOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FIX_ORDER_BASE_PATH = getResolvedPath('/clearing/operations/oms/fix-order');

export const getFixOrderPath: EntityPathBuilder<ExcRouteV1FixOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FIX_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.clOrderId) {
        return undefined;
      }

      return getResolvedPath(`${FIX_ORDER_BASE_PATH}/$fixOrderId`, { fixOrderId: context.keys.clOrderId });
    }
  }
};

export function getFixOrderDetailPath(clOrderId: string | undefined) {
  if (!clOrderId) {
    return undefined;
  }

  return getFixOrderPath({ kind: 'detail', keys: { clOrderId } });
}
